import React from "react";
import styled from "styled-components";
import { SuccessIcon } from "../../utils/icons";
import PropTypes from "prop-types";

const ToastContainer = styled.div`
  display: flex;
  align-items: center;
  ${'' /* width:383px; */}
  min-height: 90px;
  background-color: ${(props) => props.bgColor || "#DDEEDF"};
  border: 1px solid ${(props) => props.borderColor || "#39AE52"};
  border-radius: 12px;
  padding: 20px;
  color: #184a61;
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  ${'' /* background-color: #e8f5e9; */}
  border-radius: 50%;
  padding: 8px;
  margin-right: 12px;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 18px;
  font-family: Lato;
  color: #184A61;
  font
`;

const Message = styled.div`
  font-size: 14px;
  margin-top: 4px;
  color: #184A61;
  font-family: Lato;
`;

function ToastMessage({ title,message,bgColor, borderColor,icon }) {
  return (
    <ToastContainer id="toast-container" bgColor={bgColor} borderColor={borderColor}>
      {icon ? <IconContainer id="toast-icon">
        {icon}
      </IconContainer> :
        <IconContainer id="toast-icon">
          {SuccessIcon()}
        </IconContainer> }
      <ContentContainer id="toast-content">
        <Title id="toast-title">{title}</Title>
        <Message id="toast-message">{message}</Message>
      </ContentContainer>
    </ToastContainer>
  );
}

ToastMessage.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  bgColor: PropTypes.string,      
  borderColor: PropTypes.string,
  icon: PropTypes.node.isRequired,
};

export default ToastMessage;
